var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',{staticClass:"titleCard company-detail-section",attrs:{"shadow":"never","body-style":{ padding: '0px 0px 2px 0px' }}},[(_vm.isSlot)?_vm._t("title"):_c('h3',{staticClass:"title-card-title",style:({ height: _vm.height })},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }